// Sentry initialization should be imported first!
import './instrument';

import * as Sentry from '@sentry/react';
import * as React from 'react';
import { createRoot } from 'react-dom/client';

import ErrorFallback from './router/ErrorFallback';
import GoApp from './router/GoApp';

function renderGoApp() {
	window.event = undefined;
	const container = document.querySelector('#go-app-container');
	if (container) {
		const root = createRoot(container);
		root.render(
			<Sentry.ErrorBoundary
				beforeCapture={scope => {
					scope.setTag('aplication', 'react');
				}}
				fallback={({ error, componentStack, resetError, eventId }) => (
					<ErrorFallback error={error} eventId={eventId} componentStack={componentStack} resetError={resetError} />
				)}
			>
				<React.StrictMode>
					<GoApp />
				</React.StrictMode>
			</Sentry.ErrorBoundary>,
		);
	}
}

renderGoApp();
